import { render, staticRenderFns } from "./ConceptProduct.vue?vue&type=template&id=58cc3704&"
import script from "./ConceptProduct.vue?vue&type=script&lang=js&"
export * from "./ConceptProduct.vue?vue&type=script&lang=js&"
import style0 from "./ConceptProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports